// GENERATE BY ./generate.js
// DO NOT EDIT IT MANUALLY
import IconsForElementsDown from '../icons/icons-for-elements-down.svg?react'
import IconsForElementsLeft from '../icons/icons-for-elements-left.svg?react'
import OtherClose from '../icons/other-close.svg?react'
import OtherRight from '../icons/other-right.svg?react'

export const ICON_MAP = {
  iconsForElementsDown: IconsForElementsDown,
  iconsForElementsLeft: IconsForElementsLeft,
  otherClose: OtherClose,
  otherRight: OtherRight,
}
